import { createRoot } from "react-dom/client";

import { ClarityTrackerLoader } from '@shared/clarity/ClarityTrackerLoader';

import SignUp from './SignUp';
import { storeInvitationId } from './invitation';

export default class RegistrationsNew {
  init() {
    const container = document.querySelector('#sign-up')

    if (container) {
      const root = createRoot(container);

      storeInvitationId();

      root.render(
        <>
          <ClarityTrackerLoader />
          <SignUp />
        </>
      );
    }
  }
}

window.App.Pages = window.App.Pages || {}
window.App.Pages.RegistrationsNew = RegistrationsNew
